module.exports = __webpack_public_path__ + "img/wand-magic-sparkles-solid.542ce368.svg";